import { ActionTypes } from "../../constants/ActionTypes";
import { ILetterRelationArg, ILetterRelationResponse } from "../../interfaces/LetterRelation";

export const onGetLetterRelation = (params: ILetterRelationArg) => {
    return {
        type: ActionTypes.GET_LETTER_RELATION,
        payload: params
    };
};

export const fetchLetterRelationSuccess = (letterRelationList: ILetterRelationResponse[]) => {
    return {
        type: ActionTypes.FETCH_LETTER_RELATION_SUCCESS,
        payload: letterRelationList
    };
};